import { render, staticRenderFns } from "./AuthorityManage.vue?vue&type=template&id=7ffbf0f9&scoped=true"
import script from "./AuthorityManage.vue?vue&type=script&lang=ts"
export * from "./AuthorityManage.vue?vue&type=script&lang=ts"
import style0 from "./AuthorityManage.vue?vue&type=style&index=0&id=7ffbf0f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbf0f9",
  null
  
)

export default component.exports